import { makeStyles, TextField } from "@material-ui/core";
import { useState } from "react";

const useStyles = makeStyles({
  root: {
    marginTop: "5px",
    paddingBottom: "3px",
    width: "100%",
    "& .MuiOutlinedInput-root": {
      height: "50px",
      "& fieldset": {
        borderColor: "#EAEAEA",
      },
      "&:hover fieldset": {
        borderColor: "#EAEAEA",
      },
    },
  },
});

const RemarkLocationInput = ({ routeLocationData }: any) => {
  const [remarkLocation, setRemarkLocation] = useState<string>(
    routeLocationData.remark ?? undefined
  );

  const classes = useStyles();

  return (
    <TextField
      className={classes.root}
      label="Remark location pick/drop off"
      variant="outlined"
      value={remarkLocation}
      onChange={(event: any) => {
        if (event) {
          setRemarkLocation(event.target.value);
          routeLocationData.remark = event.target.value;
        } else {
          setRemarkLocation(null);
          routeLocationData.remark = null;
        }
      }}
    />
  );
};

export default RemarkLocationInput;
